var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-container"},[(_vm.isPending)?_c('div',{staticClass:"progress-container__spinner"},[_c('ProgressSpinner')],1):_c('div',{staticClass:"progress-container__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }